import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Edição de formulário")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IdFormularioFactory = _resolveComponent("IdFormularioFactory")!
  const _component_TituloInput = _resolveComponent("TituloInput")!
  const _component_SubtituloInput = _resolveComponent("SubtituloInput")!
  const _component_ListaQuestoes = _resolveComponent("ListaQuestoes")!
  const _component_ListaModelos = _resolveComponent("ListaModelos")!
  const _component_BotoesSalvarCancelar = _resolveComponent("BotoesSalvarCancelar")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    (_ctx.titulo)
      ? (_openBlock(), _createBlock(_component_IdFormularioFactory, {
          key: 0,
          titulo: (_ctx.titulo as Titulo),
          onGerouId: _ctx.alterouId
        }, null, 8, ["titulo", "onGerouId"]))
      : (_openBlock(), _createBlock(_component_IdFormularioFactory, {
          key: 1,
          onGerouId: _ctx.alterouId
        }, null, 8, ["onGerouId"])),
    (_ctx.titulo)
      ? (_openBlock(), _createBlock(_component_TituloInput, {
          key: 2,
          titulo: (_ctx.titulo as Titulo),
          onDigitou: _ctx.alterouTitulo
        }, null, 8, ["titulo", "onDigitou"]))
      : (_openBlock(), _createBlock(_component_TituloInput, {
          key: 3,
          onDigitou: _ctx.alterouTitulo
        }, null, 8, ["onDigitou"])),
    (_ctx.subtitulo)
      ? (_openBlock(), _createBlock(_component_SubtituloInput, {
          key: 4,
          subtitulo: (_ctx.subtitulo as Subtitulo),
          onDigitou: _ctx.alterouSubtitulo
        }, null, 8, ["subtitulo", "onDigitou"]))
      : (_openBlock(), _createBlock(_component_SubtituloInput, {
          key: 5,
          onDigitou: _ctx.alterouSubtitulo
        }, null, 8, ["onDigitou"])),
    _createVNode(_component_ListaQuestoes, {
      lista: (_ctx.listaQuestoes as unknown as ListaEditavel<ItemEditavel>)
    }, null, 8, ["lista"]),
    _createVNode(_component_ListaModelos, {
      lista: (_ctx.listaModelos as unknown as ListaEditavel<ModeloEditavel>)
    }, null, 8, ["lista"]),
    _createElementVNode("footer", null, [
      _createVNode(_component_BotoesSalvarCancelar, {
        onCancelou: _ctx.cancelar,
        onSalvou: _ctx.salvar
      }, null, 8, ["onCancelou", "onSalvou"])
    ])
  ]))
}